import  { useEffect } from 'react';
import AppStateContext from "./AppStateContext";
import useAppState from "./AppState";

const AppStateProvider = ({ children }) => {

  const appState = useAppState();

  useEffect(() => {
    const params = {
      query: 'SELECT * FROM fonts'
    };

    // Realizar la solicitud fetch
    fetch(process.env.REACT_APP_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error en la respuesta del servidor');
        }
        return response.json();
      })
      .then(data => {
        appState.state.set(data?.data);
        localStorage.setItem('appState', JSON.stringify(data?.data));

      })
      .catch(error => {
        console.error('Error en la solicitud:', error);
      });

  }, []);

  return (
    <AppStateContext.Provider value={appState}>
      {appState !== undefined ? children : <h1>CARGANDO</h1>}
    </AppStateContext.Provider>
  );
};

export default AppStateProvider;
